import { render, staticRenderFns } from "./SearchFacet.vue?vue&type=template&id=23695eee"
import script from "./SearchFacet.vue?vue&type=script&lang=js"
export * from "./SearchFacet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports